module.exports = __webpack_public_path__ + "img/UFI_Member-logo-06AB23A13E-seeklogo.com.c0b7d0ad.png";